
import React, { Component } from "react";




export const Ytitle = (props)=>{

  return (
    <g>
    <text x="0" y="12">{props.upper}</text>
    <text x="0" y="190">{props.lower}</text>

    </g>)

}



// WEBPACK FOOTER //
// ./src/components/Ytitle.js